import { styled, Box } from '@mui/material';
import LoadingButton from 'src/components/loadingButton';
import RichTextEditor from 'src/components/RichTextEditor';

export const ContributeRichTextEditor = styled(RichTextEditor, {
  shouldForwardProp: (prop) => prop !== 'hideToolbar' && prop !== 'size',
})<{
  hideToolbar?: boolean;
  size?: 'small' | 'large';
}>(({ hideToolbar, theme, size = 'large' }) => ({
  overflow: 'hidden',
  '& .ql-toolbar': {
    display: hideToolbar ? 'none' : 'block',
    borderRadius: '12px 12px 0px 0px',
  },
  '& .ql-editor': {
    minHeight: size === 'large' ? '100px' : '40px',
  },
  '& .ql-container': {
    height: 'fit-content',
    minHeight: size === 'large' ? '100px' : '40px',
    ...(hideToolbar
      ? {
          borderTop: `1px solid ${theme.palette.divider} !important `,
          borderRadius: '12px',
        }
      : { borderRadius: '0px 0px 12px 12px' }),
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  flex: '1',
  padding: '20px 20px 0 20px',
  display: 'flex',
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.down('md')]: {
    padding: '16px',
  },
}));

export const InheritedSpan = styled('span')({
  fontSize: 'inherit',
  color: 'inherit',
  fontWeight: 'inherit',
  fontFamily: 'inherit',
});

export const ButtonContained = styled(LoadingButton)(({ theme }) => ({
  padding: '10px 24px',
  borderRadius: '16px',
  color: 'primary.main',
  fontSize: '14px',
  fontWeight: '500',
  backgroundColor: theme.palette.background.paper,
  minWidth: '100px',
  border: '1px solid #25507B',
  ':disabled': {
    opacity: '0.7',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '10px 20px',
    fontSize: '16px',
    width: '100%',
  },
}));

export const ButtonOutlined = styled(LoadingButton)(({ theme }) => ({
  padding: '10px',
  borderRadius: '16px',
  color: 'primary.main',
  fontSize: '14px',
  minWidth: '100px',
  fontWeight: '500',
  backgroundColor: 'transparent',
  width: 'fit-content',
  border: '1px solid rgba(0, 0, 0, 0.50)',
  ':disabled': {
    opacity: '0.7',
  },
  [theme.breakpoints.down('md')]: {
    padding: '10px 20px',
    fontSize: '16px',
  },
}));

export const QuestionStatusChip = styled(Box)(({ theme }) => ({
  padding: '6px 14px',
  borderRadius: '20px',
  fontSize: '13px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.down('sm')]: {
    padding: '4px 8px',
    fontSize: '11px',
    borderRadius: '14px',
  },
}));
